import React, { useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {TextField,  Grid,  Box,  FormControl,  Select,  MenuItem,  Typography,  Card,  FormControlLabel,  Checkbox,  CardContent, InputLabel} from '@mui/material';
import statelist from '../../../utils/StateDistList.json'
export default function AddressDetails(props) {
  const {customer,addressList} = props;
  const {control,watch,reset,setValue} = useFormContext();
  const addressMode = watch('addressMode');
  const addressType = watch('addressType');
  // useEffect(()=>{
  //   if(addressType != '4'){
  //     setValue('fullName',`${customer.profile.firstName || ''} ${customer.profile.middleName || ''} ${customer.profile.lastName || ''}`.replace(/\s+/g, ' ').trim());
  //     setValue('mobileNumber',customer?.mobileNumber);
  //   }else{
  //     setValue('fullName','');
  //     setValue('mobileNumber','');
  //   }
  // },[addressType]);
  useEffect(()=>{
      if(addressType != '4'){
        setValue('tagName','',{ shouldValidate: true });
        setValue('fullName',`${customer.profile.firstName || ''} ${customer.profile.middleName || ''} ${customer.profile.lastName || ''}`.replace(/\s+/g, ' ').trim());
        setValue('mobileNumber',customer?.mobileNumber);
        if(addressType == '1'){
          setValue('tagName','Home',{ shouldValidate: true });
        }else if(addressType == '2'){
          setValue('tagName','Work',{ shouldValidate: true });
        }
      }else{
        setValue('fullName','');
        setValue('mobileNumber','');
        if(addressType == '4'){
          setValue('tagName','Friends and Family',{ shouldValidate: true });
        }
      }
    },[addressType]);

  const isHomeAddressExists = addressList?.some(address => address.addressType == '1');
  const isWorkAddressExists = addressList?.some(address => address.addressType == '2');
  return (
    
    <Grid container sx={{p:'2% 5%'}}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <Box>
              {/* <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Flat/House No<span style={{color:'#d32f2f'}}>*</span></Typography> */}
              <Controller
                control={control}
                name='address'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    disabled={!watch('address')}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={12} lg={5}>
            <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>Address Type<span style={{color:'#d32f2f'}}>*</span></Typography>
            <Controller
              name='addressType'
              control={control}
              rules={{
                required:'required'
              }}
              render={({field,fieldState:{error}})=>(
                <FormControl fullWidth size='small'>
                  <Select
                    // labelId="demo-simple-select-label"
                    {...field}
                    value={field.value || ''}
                    // label='Address Type'
                    sx={{
                      // minHeight: '0px',
                      // height: '1.6rem',
                      fontSize: '0.75rem',
                      '& .MuiSelect-select': {
                        // padding: '0 8px',
                        display: 'flex',
                        alignItems: 'center',
                      },
                    }}
                    error={!!error}
                  >
                    {!isHomeAddressExists && <MenuItem sx={{fontSize:'0.75rem'}} value='1'>Home</MenuItem>}
                    {!isWorkAddressExists && <MenuItem sx={{fontSize:'0.75rem'}} value='2'>Work</MenuItem>}
                    <MenuItem sx={{fontSize:'0.75rem'}} value='3'>Other</MenuItem>
                    <MenuItem sx={{fontSize:'0.75rem'}} value='4'>Friends & Family</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={2}/>
          <Grid item xs={12} lg={5}>
              <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>Label<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                name='tagName'
                control={control}
                rules={{
                  required:'required'
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    size='small'
                    fullWidth
                    disabled={addressType != '3'}
                    InputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    onChange={(e)=>{
                      const value = e.target.value;
                      let formattedValue = value.replace(/\s+/g, ' ').trimStart();
                      // allow only three words
                      const words = formattedValue.split(' ');
                      if(words.length > 3){
                        // limit to first three words
                        const limitedWords = words.slice(0,3);
                        const limitedValue = limitedWords.join(' ');
                        field.onChange(limitedValue);
                        return; 
                      }
                      field.onChange(formattedValue);
                    }}
                    error={!!error}
                  />
                )}
              />
          </Grid>
          <Grid item xs={12} lg={5}>
            <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>FullName</Typography>
            <Controller
              name='fullName'
              control={control}
              rules={{
                validate:(value)=>{
                  if (addressType == '4' && !value) return 'Empty Not allowed';
                  return true;
                }
              }}
              render={({field,fieldState:{error}})=>(
                <TextField
                  {...field}
                  size='small'
                  fullWidth
                  disabled={addressType != '4'}
                  InputProps={{
                    style:{
                      fontSize:'0.75rem'
                    }
                  }}
                  onChange={(e)=>{
                    const value = e.target.value;
                    let formattedValue = value.replace(/\s+/g, ' ').trimStart();
                    // allow only three words
                    const words = formattedValue.split(' ');
                    if(words.length > 3){
                      // limit to first three words
                      const limitedWords = words.slice(0,3);
                      const limitedValue = limitedWords.join(' ');
                      field.onChange(limitedValue);
                      return; 
                    }
                    field.onChange(formattedValue);
                  }}
                  error={!!error}
                />
              )}
            />
          </Grid>
          <Grid item xs={2}/>
          <Grid item xs={12} lg={4}>
            <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>Mobile Number</Typography>
            <Controller
              name='mobileNumber'
              control={control}
              rules={{
                pattern: {
                    value: /^[1-9][0-9]{9}$/,
                    message: "Enter a valid 10-digit number not starting with 0"
                },
                validate:(value)=>{
                  if (addressType == '4' && !value) return 'Empty Not allowed';
                  if (value && value.length !== 10) {
                    return "Mobile number must be exactly 10 digits";
                  }
                  return true;
                }
              }}
              render={({field,fieldState:{error}})=>(
                <TextField
                  {...field}
                  size='small'
                  fullWidth
                  type='number'
                  disabled={addressType != '4'}
                  InputProps={{
                    style:{
                      fontSize:'0.75rem'
                    }
                  }}
                  onChange={(e)=>{
                    const value = e.target.value;
                    // prevent entering more than 10 digits
                    const trimmedValue = value.slice(0, 10);
                    field.onChange(trimmedValue);
                  }}
                  error={!!error}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Flat/House No</Typography>
              <Controller
                control={control}
                name='houseFlatBlockNo'
                rules={{
                  // validate:(value)=>{
                  //   if (!value) return 'Empty Not allowed';
                  //   return true;
                  // }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2}/>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Apartment/ Road/ Area</Typography>
              <Controller
                control={control}
                name='apartmentRoadArea'
                rules={{
                  // required:'required',
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                  />
                )}
              />  
            </Box> 
          </Grid>

          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Landmark</Typography>
              <Controller
                control={control}
                name='landmark'
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2}/>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>State<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='state'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <FormControl fullWidth size='small'>
                    <Select
                      {...field}
                      value={field.value || ''}
                      disabled={addressMode=='select_address'}
                      sx={{
                        // minHeight: '0px',
                        // height: '1.6rem',
                        fontSize: '0.75rem',
                        '& .MuiSelect-select': {
                          // padding: '0 8px',
                          display: 'flex',
                          alignItems: 'center',
                        },
                      }}
                      error={!!error}
                    >
                      {statelist.map((listItem,index)=>(
                        <MenuItem sx={{fontSize:'0.75rem'}} key={index} value={listItem.state}>{listItem.state}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />  
            </Box> 
          </Grid>

          
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>City<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='city'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Pincode<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='pincode'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    type='number'
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Latitude<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='latitude'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    type='number'
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Longitude<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='longitude'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    type='number'
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
        </Grid>
      </Grid>
    </Grid>
        
  );
}